import { seatWidgetIframe, seatWidgetAjax } from '../utils/seat-widget-ajax.js'

import ajaxFunc from '../utils/ajax.js'

// import getUrlParameter from '../utils/get-url-parameter'
export function iframeLoad(frame, src, chartRatio) {
  return new Promise((resolve, reject) => {
    frame.src = src
    frame.width = 800
    frame.height = 800 / chartRatio
    if (frame.complete) {
      console.info('frame.completed')
      resolve()
    } else {
      frame.onload = e => {
        console.info('frame.loaded')
        resolve(e)
      }

      frame.onerror = err => {
        reject(err)
      }
    }
  })
}

export function cleanLoading(elm) {
  elm.classList.remove('lazy-loading')
}
export function openIframeOnSuccess(frameSrc, newImg, chartRatio) {
  const imageWrapList = document.querySelectorAll(newImg)
  const domLists = imageWrapList.length
  for (let i = 0; i < domLists; i++) {
    const frame = imageWrapList[i]
    function addIframeUrl(frame) {
      iframeLoad(frame, frameSrc, chartRatio).then(() => {
        frame.classList.remove('lazy-loading')
      })
    }

    addIframeUrl(frame)
  }
}

export function updateSeatsIframe() {
  const width = window.chartVars.chartWidth
  const height = window.chartVars.chartHeight
  const chartRatio = height / width

  // if (!isReturn) {
  const $selSeats = $('.order-details-item').map(function() {
    return $(this).attr('data-seat-eid')
  })

  const selSeatsArr = $.makeArray($selSeats)
  const selectSeatsEid = selSeatsArr.join(',')

  const frameSrc = seatWidgetIframe(
    window.myvars.scheduleEid,
    selectSeatsEid,
    800,
    chartRatio,
    false
  )

  const img = '.seats-found-img'
  openIframeOnSuccess(frameSrc, img, chartRatio)

  // console.info(`frameSrc: ${frameSrc}`)
}

export function injectSeatWidget(payLoad) {
  // const img = $(payLoad).find('#canvas-img')

  // $('#widget-chart-img').attr('src', img.attr('src'))
  const loadDiv = $('.seats-found-img')

  loadDiv.html(payLoad)
}

export function loadSeatWidget() {
  const width = window.chartVars.chartWidth
  const height = window.chartVars.chartHeight
  const chartRatio = height / width
  const $selSeats = $('.order-details-item').map(function() {
    return $(this).attr('data-seat-eid')
  })

  const selSeatsArr = $.makeArray($selSeats)
  const selectSeatsEid = selSeatsArr.join(',')

  const seatWidgetUrl = seatWidgetAjax(
    myvars.scheduleEid,
    800,
    chartRatio,
    false
  )

  const sendData = {
    selectSeats: selectSeatsEid
  }
  // console.info(`sendData: ${sendData}`)

  ajaxFunc(seatWidgetUrl, sendData, injectSeatWidget)
}

window.loadSeatWidget = loadSeatWidget
window.cleanLoading = cleanLoading
// window.getUrlParameter = getUrlParameter

// export default updateSeatsIframe
